function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M44.385,27.385C42.01,24.6,39.968,24.3,33.88,22.448c-.52-.148-5.011-1.3-4.974-4.454-.223-4.046,5.271-4.269,6.422-4.195,4.64-.074,6.942,1.67,8.2,1.782.557,0,.817-.334.817-1.076V12.8a1.822,1.822,0,0,0-.334-1.151C42.529,9.715,36.85,9.01,34.771,9.01c-7.424,0-11.693,4.64-11.582,9.354,0,6.459,6.533,8.5,7.276,8.723,6.273,1.967,7.127,2.042,8.872,3.526a3.8,3.8,0,0,1-.891,5.791c-.631.371-3.341,2-9.466.742a21.323,21.323,0,0,1-4.789-1.6c-.445-.148-1.485-.408-1.485.965v1.819a2.247,2.247,0,0,0,1.3,2,22.993,22.993,0,0,0,9.577,2.042c.148,0,8.686.007,11.545-5.754C45.718,35.44,47.244,31.1,44.385,27.385Z",
  transform: "translate(57.868 -8.96)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M53.675,10.717c-.074.3.557-1.745-8.8,28.36a1.927,1.927,0,0,1-2.153,1.708H39.644A1.931,1.931,0,0,1,37.528,39L32,16.1,26.54,38.966a1.946,1.946,0,0,1-2.153,1.782H21.343a1.877,1.877,0,0,1-2.079-1.708L10.949,11.608a6.8,6.8,0,0,1-.334-1.448.787.787,0,0,1,.631-.891H15a1.887,1.887,0,0,1,2.079,1.745l5.939,23.46,5.531-23.46A1.911,1.911,0,0,1,30.7,9.307h2.858a1.813,1.813,0,0,1,2.116,1.708L41.24,34.809,47.4,11.014a1.871,1.871,0,0,1,2.079-1.708h3.3C52.933,9.27,53.824,9.158,53.675,10.717Z",
  transform: "translate(25.044 -8.292)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M28.517,32.247V20.665a11.79,11.79,0,0,0-2.97-8.723,12.7,12.7,0,0,0-9.243-2.9c-5.048,0-10.171,1.967-11.025,3.044-.223.445-.742,4.046.483,4.046a3.032,3.032,0,0,0,1.782-.483,20.984,20.984,0,0,1,7.684-1.708c5.011-.483,7.907,2.933,7.461,7.35v2.6a32.081,32.081,0,0,0-7.832-1.039C8.694,22.484,3,25.736,3,32.878c0,7.832,6.994,9.5,9.7,9.392a13.342,13.342,0,0,0,10.468-4.937C25.213,41.9,26.512,41.6,26.549,41.6a1.779,1.779,0,0,0,.965-.334l2.116-1.485a1.385,1.385,0,0,0,.705-1.039C30.3,37.666,28.368,36,28.517,32.247Zm-6.2.3c-.52,1.782-2.821,5.011-8.241,5.086A4.649,4.649,0,0,1,9.1,32.544c-.186-4.454,4.417-5.568,6.979-5.382a31.133,31.133,0,0,1,6.57.817A16.671,16.671,0,0,1,22.318,32.544Z",
  transform: "translate(4.421 -8.997)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M101.654,28.951C89.46,38.306,71.791,43.273,56.575,43.273c-21.333,0-40.547-6.674-55.087-20.312-1.128-1.084-.122-2.546,1.251-1.715,15.687,9.5,35.075,13.683,55.106,13.683a105.972,105.972,0,0,0,42.039-8.939C101.951,25.069,103.67,27.4,101.654,28.951Z",
  transform: "translate(-1.001 23.557)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M39.554,24.886c-1.388-1.774-9.158-.835-12.647-.416-1.065.123-1.236-.8-.278-1.466,6.207-4.354,16.366-3.1,17.558-1.637s-.323,11.66-6.129,16.522c-.895.742-1.745.342-1.344-.635C38.01,33.981,40.946,26.661,39.554,24.886Z",
  transform: "translate(66.798 20.848)"
});

function SvgAws(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-amazon-web-services",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.361,
    height: 66.83,
    viewBox: "0 0 111.361 66.83",
    transform: "translate(0 18)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/AWS.b2f95363.svg";
export { ForwardRef as ReactComponent };